<template>
  <v-app-bar class="app-bg-success" app density="comfortable" flat>
    <RouterLink to="/" class="d-flex align-center app-text-white text-decoration-none">
      <span class="ml-1"><v-icon start>mdi-account-circle-outline</v-icon>{{ usuario.nombre_completo }}</span>
      <v-tooltip activator="parent" location="top">Ver Menú</v-tooltip>
    </RouterLink>

    <v-spacer></v-spacer>

    <v-menu>
      <template #activator="{ props }">
        <v-btn icon v-bind="props" class="app-text-white">
          <v-icon>mdi-menu</v-icon>
          <v-tooltip activator="parent" location="top">Otras opciones</v-tooltip>
        </v-btn>
      </template>

      <v-list>
        <v-list-item v-for="(configuracion, index) in configuraciones" :key="index" @click="accionMenu(configuracion)">
          <v-list-item-title>
            <v-icon class="text-success mr-2">{{ configuracion.icon }}</v-icon>
            {{ configuracion.titulo }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog v-model="dialogCerrarSesion" max-width="400" persistent>
      <v-card>
        <v-card-title class="app-bg-success app-text-white d-flex justify-space-between align-center">
          <span>¿Quiere cerrar la sesión?</span>
          <v-btn class="app-text-success" icon @click="dialogCerrarSesion = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="scrollable-card-text text-center">
          <p>Cerrar Sesión</p>
          <v-row class="mt-2">
            <v-col cols="6">
              <v-btn class="app-bg-secondary app-text-white" block @click="dialogCerrarSesion = false">
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn class="app-text-white app-bg-success" block @click="cerrarSesion()">
                Si, Cerrar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>
<script>
import store from '@/store'
export default {
  data() {
    return {
      configuraciones: [
        { titulo: 'Mi Perfil', icon: 'mdi-account-circle-outline', value: 'ver_perfil' },
        { titulo: 'U. EDS', icon: 'mdi-store-marker', value: 'ubicacion_eds' },
        { titulo: 'EDS', icon: 'mdi-store', value: 'eds' },
        { titulo: 'A. Disponibles', icon: 'mdi-cash-multiple', value: 'anticipos_disponibles' },
        { titulo: 'Lecturas Sin Cierre', icon: 'mdi-fuel', value: 'lecturas_mangueras_sin_cierre' },
        { titulo: 'C. Turnos', icon: 'mdi-clock-check-outline', value: 'cierres_turnos' },
        { titulo: 'Ver Auditoria', icon: 'mdi-file-search', value: 'auditoria' },
        { titulo: 'Surtidores', icon: 'mdi-gas-station', value: 'surtidor' },
        { titulo: 'Cerrar Sesión', icon: 'mdi-logout', value: 'cerrar_sesion' }
      ],
      usuario: store.state.usuario,
      dialogCerrarSesion: false
    }
  },
  methods: {
    accionMenu(opcion) {
      if (opcion.value === "ver_perfil") {
        this.$router.push('/app/admin/perfil-admin')
      } else if (opcion.value === "auditoria") {
        this.$router.push('/app/admin/logs')
      } else if (opcion.value === "auditoria") {
        this.$router.push('/app/admin/logs')
      } else if (opcion.value === "ubicacion_eds") {
        this.$router.push('/app/admin/ubicaciones-eds-admin')
      } else if (opcion.value === "eds") {
        this.$router.push('/app/admin/eds-admin')
      } else if (opcion.value === "anticipos_disponibles") {
        this.$router.push('/app/admin/anticipos-disponibles')
      } else if (opcion.value === "cierres_turnos") {
        this.$router.push('/app/admin/cierres-turnos')
      } else if (opcion.value === "surtidor") {
        this.$router.push('/app/admin/surtidores')
      } else if (opcion.value === "lecturas_mangueras_sin_cierre") {
        this.$router.push('/app/admin/lecturas-mangueras-sin-cierre')
      } else if (opcion.value === "cerrar_sesion") {
        this.dialogCerrarSesion = true
      }
    },
    cerrarSesion() {
      const datoEnviar = {
        usuario_codigo: this.usuario.codigo
      }
      this.axios
        .post("usuario/cerrarsesion", datoEnviar)
        .then((respuesta) => {
          if (respuesta.status === 200) {
            localStorage.clear()
            window.location = '/'
          }
        })
        .catch((error) => {
          console.log(error, error);
        });
    }
  }
}
</script>